import { render, staticRenderFns } from "./EventUpload.vue?vue&type=template&id=5619b230&scoped=true"
import script from "./EventUpload.vue?vue&type=script&lang=js"
export * from "./EventUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619b230",
  null
  
)

export default component.exports